export function findIdTokenKey() {
  return Object.keys(localStorage).find(
    (item) =>
      item.startsWith(
        `CognitoIdentityServiceProvider.${process.env.REACT_APP_AMAZON_USER_POOL_WEB_CLIENT_ID}`,
      ) && item.endsWith('idToken'),
  );
}
